import PropTypes from 'prop-types'
import './ContentItem.css'

export default function ContentItem({ content }) {
  return (
    <article className="content-item-container" itemScope itemType="https://schema.org/TVSeries">
      <div className="content-item-wrapper">
        <div className="content-item-content">
          {/* Poster Image */}
          <figure className="content-item-poster">
            <img 
              src={content.poster} 
              alt={content.title}
              className="content-item-poster-image"
              itemProp="image"
            />
          </figure>
          
          {/* Information Section */}
          <div className="content-item-info">
            {/* Title */}
            <header className="content-item-title-section">
              <p className="content-item-category" itemProp="genre">{content.category}</p>
              <h2 className="content-item-title" itemProp="name">{content.title}</h2>
            </header>
            
            {/* Divider */}
            <hr className="content-item-divider" />
            
            {/* Details */}
            <dl className="content-item-details">
              {content.details.map((detail, index) => (
                <div key={index} className="content-item-detail-row">
                  <dt className="content-item-detail-label">{detail.label}</dt>
                  <dd className="content-item-detail-value">{detail.value}</dd>
                </div>
              ))}
            </dl>
            
            {/* Divider */}
            <hr className="content-item-divider" />
            
            {/* Summary */}
            <p className="content-item-summary" itemProp="description">
              {content.summary}
            </p>
            
            {/* Description */}
            {content.description && (
              <p className="content-item-description">
                {content.description}
              </p>
            )}
            
            {/* Button */}
            <a 
              href={content.buttonLink} 
              className="content-item-button"
              itemProp="url"
              rel="noopener noreferrer"
            >
              {content.buttonText}
            </a>
          </div>
        </div>
      </div>
    </article>
  )
}

ContentItem.propTypes = {
  content: PropTypes.shape({
    poster: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    details: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
      })
    ).isRequired,
    summary: PropTypes.string.isRequired,
    description: PropTypes.string,
    buttonLink: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired
  }).isRequired
}
